import { render, staticRenderFns } from "./my_box.vue?vue&type=template&id=bec92d12&scoped=true&"
import script from "./my_box.vue?vue&type=script&lang=js&"
export * from "./my_box.vue?vue&type=script&lang=js&"
import style0 from "./my_box.vue?vue&type=style&index=0&id=bec92d12&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec92d12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bec92d12')) {
      api.createRecord('bec92d12', component.options)
    } else {
      api.reload('bec92d12', component.options)
    }
    module.hot.accept("./my_box.vue?vue&type=template&id=bec92d12&scoped=true&", function () {
      api.rerender('bec92d12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/homeNew/components/my_box.vue"
export default component.exports